import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ObjectToJsonStepperCreatorService {

  constructor(
    private translate: TranslateService) { }

  public createJsonFromObject(numberOfObj: number, contentIntitule: any, contentFragmentId: string, form: string,
                              stepNumber: string, numberOfSection: number, numberOfSousSection: number[], hide?: HideConfig[]): any[] {
    /**
    numberOfObj : nombre de répétitions (0 si on cache, plusieurs si plusieurs lots)
    contentIntitule : nom de la step, utilisé où?
    contentFragmentId: link sur le step id
    form: 1ere partie pour fr.json?
    stepNumber: indexPage
    numberOfSection: explicite
    numberOfSousSection: tableau de mort
    hide?: utile?

    notes : créer un form-message avec nom des steps, déployer sur les fieldset et contentIntitule
    **/

    const json: JsonSchema = new JsonSchema();
    let content = new Content();
    let sections = new Sections();
    let sousSections = new SousSections();
    for (let i = 0; i < numberOfObj; i++) {
      content.intitule = this.translate.instant(contentIntitule);
      content.idFragment = contentFragmentId;
      for (let j = 0; j < numberOfSection; j++) {
        sections.intitule = 'form.' + form + '.step' + stepNumber + '_section' + (j + 1);
        sections.idFragment = 'step' + stepNumber + '_section' + (j + 1);
        for (let y = 0; y < numberOfSousSection[j]; y++) {
          sousSections.intitule = 'form.' + form + '.step' + stepNumber + '_section' + (j + 1) + '_soussection' + (y + 1);
          sousSections.idFragment = 'step' + stepNumber + '_section' + (j + 1) + '_soussection' + (y + 1);
          sections.sousSections.push(sousSections);
          sousSections = new SousSections();
        }
        content.sections.push(sections);
        sections = new Sections();
      }
      json.content.push(content);
      content = new Content();
    }
    return this.hideService(json.content, hide);
  }


  public testNewJsonFromObject(contentIntitule: any, contentFragmentId: string, form: string,
                               stepNumber: string, sections: any[]) {
    const numberOfSousSection: number[] = new Array();
    sections?.forEach(section => numberOfSousSection.push(section.length));
    return this.createNewJsonFromObject(form,
      parseInt(stepNumber), numberOfSousSection);
  }

  public createNewJsonFromObject(form: string, stepNumber: number, structure: any, objects = false, hide?: HideConfig[]): any[] {
    /**
     * Cette fonction permet d'afficher la table des matières sur les différents formulaires, à utiliser sur form.component.html de la manière suivante :
     * [myArray]="objectToJsonStepperCreatorService.createNewJsonFromObject(form17.step + indexPage, '17', indexPage, getContents(indexPage), getObjects(indexPage))"
     * getContents : crée un tableau dynamique en fonction de la step dans laquelle on se trouve
     * getObjects : indique si la structure comprend un niveau 0 (objets)
     * Les numéros de section et sous-section correspondent aux numéros affichés/dans fr.json (form.[f].step[i]_section[j]_soussection[k])
          form: nom du formulaire, sert à récupérer le nom des sections dans fr.json
          stepNumber: indexPage, sert à récupérer le nom des sections dans fr.json
          structure: modèle de la table des matières, tableau-ception de nombres
                      niveau 0 (si objects est vrai) : structure des différents objets/lots (répéter si identiques)
                      niveau 1 : structure des sections - chiffre si suite sans sous-section [0,0,0,0] = 4 -
                                                            tableau pour plus de précision ou pour noter le nombre de sous-section par section
                      niveau 2 : structure des sous-sections - chiffre si suite [4] = [[1,2,3,4]]
                                                            tableau pour préciser quelle sous-section est dans la section
                      ex : [0, null, 2, [1,6]] sera décrit comme suit
                        stepx.1
                        stepx.3
                          stepx.3.1
                          stepx.3.2
                        stepx.4
                          stepx.4.1
                          stepx.4.6
          objects : indique si la structure a un niveau 0
          hide: Permet d'annoncer les champs cachés

    notes : créer un form-message avec nom des steps, déployer sur les fieldset et contentIntitule
    **/
    

    

    const json: JsonSchema = new JsonSchema();
    let content: Content;
    let sections: Sections;
    let sousSections: SousSections;

    /* On n'affiche la table des matières que pour la partie 4 */
    if (stepNumber < 4 || stepNumber > 19) {
      return json.content;
    }

    if (structure == null) {
      structure = [];
    }
    let numberOfObj = objects ? structure.length : 1;
    let objFragment = '';
    for (let i = 0; i < numberOfObj; i++) {
      content = new Content();
      if (objects) {
        objFragment = '_object' + (i + 1);
      }
      content.intitule = 'stepper.form.' + form + '.step' + stepNumber;
      if (!this.hasTranslation(content.intitule)) {
        content.intitule = this.getCommun(content.intitule);
      }
      content.idFragment = 'step' + stepNumber + objFragment;
      let numberOfSousSections = structure;
      if (objects) {
        numberOfSousSections = structure[i];
      }

      let numberOfSection = 1;
      if (Array.isArray(numberOfSousSections)) {
        numberOfSection = numberOfSousSections?.length;
      } else if (Number.isInteger(numberOfSousSections)) {
        numberOfSection = numberOfSousSections;
      }
      for (let j = 0; j < numberOfSection; j++) {
        sections = new Sections();
        sections.intitule = 'form.' + form + '.step' + stepNumber + '_section' + (j + 1);
        if (!this.hasTranslation(sections.intitule)) {
          sections.intitule = this.getCommun(sections.intitule);
          if (!this.hasTranslation(sections.intitule)) {
            continue;
          }
        }
        sections.idFragment = 'step' + stepNumber + objFragment + '_section' + (j + 1);

        let numberOfSousSection = 0;
        if (Array.isArray(numberOfSousSections)) {
          if (Array.isArray(numberOfSousSections[j])) {
            numberOfSousSection = numberOfSousSections[j]?.at(-1);
          } else if (Number.isInteger(numberOfSousSections[j])) {
            numberOfSousSection = numberOfSousSections[j];
          } else if (numberOfSousSection[j] == null) {
            continue;
          }
        }
        for (let y = 0; y < numberOfSousSection; y++) {
          sousSections = new SousSections();
          if (Array.isArray(numberOfSousSections[j]) && !numberOfSousSections[j].includes(y + 1)) {
            continue;
          }
          sousSections.intitule = 'form.' + form + '.step' + stepNumber + '_section' + (j + 1) + '_soussection' + (y + 1);
          if (!this.hasTranslation(sousSections.intitule)) {
            sousSections.intitule = this.getCommun(sousSections.intitule);
            if (!this.hasTranslation(sousSections.intitule)) {
              continue;
            }
          }
          sousSections.idFragment = 'step' + stepNumber + objFragment  + '_section' + (j + 1) + '_soussection' + (y + 1);
          
          sections.sousSections.push(sousSections);
        }

        content.sections.push(sections);
      }
      json.content.push(content);
    }
    return this.hideService(json.content, hide);
  }

  hasTranslation(text) {
    return this.translate.instant(text) != text;
  }

  getCommun(intitule: String) {
    const form = intitule.split('.')[0] == 'form' ? intitule.split('.')[1] : intitule.split('.')[2];
    let commun = intitule.split('.')[0] == 'form' ? 'common.' : 'commun.';
    if (Number(form).toString() != 'NaN') {
      commun += 'joue';
    }
    if (form.includes('mapa')) {
      commun += 'mapa';
    }
    if (form.toUpperCase().includes('SIMP')) {
      commun += 'SIMP';
    }
    if (form.toUpperCase().includes('divers')) {
      commun += 'divers';
    }
    return intitule.replace(form, commun);
  }

  hideService(content: Content[], hide: HideConfig[]) {
    if (content.length > 0 && hide) {
      hide.forEach((obj) => {
        if (obj.separator && obj.section) {
          for (let index = 0; index < obj.value.size; index++) {
            if (content[index]) {
              for (let i = 0; i < obj.separator; i++) {
                content[index].sections[obj.section - 1].sousSections[i].hidden = obj.value.get(index);
                content[index].sections[obj.section - 1].sousSections[obj.separator + i].hidden = this.getOtherBool(obj.value.get(index));
              }
            } else {
              content[index].sections[obj.section - 1].sousSections.forEach(
                (sSections) => {
                  sSections.hidden = true;
                }
              );
            }
          }
        }
      });
    }
    return content;
    // TO DO: Hide les sous sections proposées
    /*else if (obj.section && obj.sousSection) {
        obj.sousSection.forEach((sousSection) => {
          content.sections[obj.section-1].sousSections[sousSection].hidden = obj.value;
        });
      }*/
  }

  getOtherBool(b: boolean) {
    return !b;
  }
}

export class HideConfig {
  section: number;
  separator: number;
  sousSection: number[];
  value: Map<number, boolean>;

  constructor() {
  }
}

export class JsonSchema {
  content: Content[];

  constructor() {
    this.content = [];
  }
}

export class Content {
  intitule: string;
  idFragment: string;
  sections: Sections[];

  constructor() {
    this.sections = [];
  }
}

export class Sections {
  intitule: string;
  idFragment: string;
  sousSections: SousSections[];
  hidden: boolean;

  constructor() {
    this.sousSections = [];
    this.hidden = false;
  }
}

export class SousSections {
  intitule: string;
  idFragment: string;
  hidden: boolean;

  constructor() {
    this.hidden = false;
  }
}
